import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import DashboardCrm from "../pages/DashboardCrm";
import DashboardEcommerce from "../pages/DashboardEcommerce";

import DashboardCrypto from "../pages/DashboardCrypto";
import DashboardProject from "../pages/DashboardProject";

//Calendar
// Email box
import MailInbox from "../pages/EmailInbox";

//CHat
import Chat from "../pages/Chat";
import Calendar from "../pages/Calendar";

// Project
import ProjectList from "../pages/Projects/ProjectList";
import ProjectOverview from "../pages/Projects/ProjectOverview";
import CreateProject from "../pages/Projects/CreateProject";

//Task
import TaskDetails from "../pages/Tasks/TaskDetails";
import TaskList from "../pages/Tasks/TaskList";
import KanbanBoard from "../pages/Tasks/KanbanBoard/Index";

//Transactions
import Transactions from '../pages/Crypto/Transactions';
import BuySell from '../pages/Crypto/BuySell';
import CryproOrder from '../pages/Crypto/CryptoOrder';
import MyWallet from '../pages/Crypto/MyWallet';
import ICOList from '../pages/Crypto/ICOList';
import KYCVerification from '../pages/Crypto/KYCVerification';

//Crm Pages
import CrmCompanies from "../pages/Crm/CrmCompanies";
import CrmContacts from "../pages/Crm/CrmContacts";
import CrmDeals from "../pages/Crm/CrmDeals/index";
import CrmLeads from "../pages/Crm/CrmLeads/index";

//Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";

// Support Tickets
import ListView from '../pages/SupportTickets/ListView';
import TicketsDetails from '../pages/SupportTickets/TicketsDetails';

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceProducts/EcommerceAddProduct";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceOrderDetail from "../pages/Ecommerce/EcommerceOrders/EcommerceOrderDetail";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceSellers from "../pages/Ecommerce/EcommerceSellers/index";
import EcommerceSellerDetail from "../pages/Ecommerce/EcommerceSellers/EcommerceSellerDetail";

// Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// Advance Ui
import UiNestableList from "../pages/AdvanceUi/UiNestableList/UiNestableList";
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiTour from "../pages/AdvanceUi/UiTour/UiTour";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// Widgets
import Widgets from '../pages/Widgets/Index';

//Forms
import BasicElements from "../pages/Forms/BasicElements/BasicElements";
import FormSelect from "../pages/Forms/FormSelect/FormSelect";
import FormEditor from "../pages/Forms/FormEditor/FormEditor";
import CheckBoxAndRadio from "../pages/Forms/CheckboxAndRadio/CheckBoxAndRadio";
import Masks from "../pages/Forms/Masks/Masks";
import FileUpload from "../pages/Forms/FileUpload/FileUpload";
import FormPickers from "../pages/Forms/FormPickers/FormPickers";
import FormRangeSlider from "../pages/Forms/FormRangeSlider/FormRangeSlider";
import Formlayouts from "../pages/Forms/FormLayouts/Formlayouts";
import FormValidation from "../pages/Forms/FormValidation/FormValidation";
import FormWizard from "../pages/Forms/FormWizard/FormWizard";
import FormAdvanced from "../pages/Forms/FormAdvanced/FormAdvanced";

//Tables
import BasicTables from '../pages/Tables/BasicTables/BasicTables';
import GridTables from '../pages/Tables/GridTables/GridTables';
import ListTables from '../pages/Tables/ListTables/ListTables';

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";

//Maps
import GoogleMaps from "../pages/Maps/GoogleMaps/GoogleMaps";
import VectorMaps from "../pages/Maps/VectorMaps/VectorMaps";
import LeafletMaps from "../pages/Maps/LeafletMaps/LeafletMaps";

//AuthenticationInner pages
import BasicSignIn from '../pages/AuthenticationInner/Login/BasicSignIn';
import CoverSignIn from '../pages/AuthenticationInner/Login/CoverSignIn';
import BasicSignUp from '../pages/AuthenticationInner/Register/BasicSignUp';
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from '../pages/AuthenticationInner/PasswordReset/BasicPasswReset';
//pages
import Starter from '../pages/Pages/Starter/Starter';
import SimplePage from '../pages/Pages/Profile/SimplePage/SimplePage';
import Settings from '../pages/Pages/Profile/Settings/Settings';
import Team from '../pages/Pages/Team/Team';
import Timeline from '../pages/Pages/Timeline/Timeline';
import Faqs from '../pages/Pages/Faqs/Faqs';
import Pricing from '../pages/Pages/Pricing/Pricing';
import Gallery from '../pages/Pages/Gallery/Gallery';
import Maintenance from '../pages/Pages/Maintenance/Maintenance';
import ComingSoon from '../pages/Pages/ComingSoon/ComingSoon';
import SiteMap from '../pages/Pages/SiteMap/SiteMap';
import SearchResults from '../pages/Pages/SearchResults/SearchResults';

import CoverPasswReset from '../pages/AuthenticationInner/PasswordReset/CoverPasswReset';
import BasicLockScreen from '../pages/AuthenticationInner/LockScreen/BasicLockScr';
import CoverLockScreen from '../pages/AuthenticationInner/LockScreen/CoverLockScr';
import BasicLogout from '../pages/AuthenticationInner/Logout/BasicLogout';
import CoverLogout from '../pages/AuthenticationInner/Logout/CoverLogout';
import BasicSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg';
import CoverSuccessMsg from '../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg';
import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import CoverTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';
import Cover404 from '../pages/AuthenticationInner/Errors/Cover404';
import Alt404 from '../pages/AuthenticationInner/Errors/Alt404';
import Error500 from '../pages/AuthenticationInner/Errors/Error500';



//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";





//-----------------Bitesaver---------


import ResetPassword from "../pages/Authentication/ResetPassword";


import CategoriesList from "../FindagramAdmin/Categories/CategoriesList";
import AddCategories from "../FindagramAdmin/Categories/AddCategories";
import UpdateCategories from "../FindagramAdmin/Categories/UpdateCategories";

import UserList from "../FindagramAdmin/Users/UserList";

import BusinessList from "../FindagramAdmin/Business/BusinessList";
import BusinessDetail from "../FindagramAdmin/Business/BusinessDetail";


import BlogsList from "../FindagramAdmin/Blogs/BlogsList";
import AddBlogs from "../FindagramAdmin/Blogs/AddBlogs";
import EditBlog from "../FindagramAdmin/Blogs/EditBlog";

import ProfileList from "../FindagramAdmin/ProfileManagement/ProfileList";
import ResturantDetail from "../FindagramAdmin/ProfileManagement/ResturantDetail";
import UpdateResturant from "../FindagramAdmin/ProfileManagement/UpdateResturant";
import AddBusinessProfile from "../FindagramAdmin/ProfileManagement/AddBusinessProfile";
import DetailDailySpecial from "../FindagramAdmin/DealComponents/DailySpecial/DetailDailySpecial";

import BDealList from "../FindagramAdmin/BusinessDeal/BDealList";

import AddBDailySpecial from "../FindagramAdmin/DealComponents/DailySpecial/AddBDailySpecial";
import UpdateDailySpecial from "../FindagramAdmin/DealComponents/DailySpecial/UpdateDailySpecial";


import AddLunchSpecial from "../FindagramAdmin/DealComponents/LunchSpecial/AddLunchSpecial";
import DetailLunchSpecial from "../FindagramAdmin/DealComponents/LunchSpecial/DetailLunchSpecial";
import UpdateLunchSpecial from "../FindagramAdmin/DealComponents/LunchSpecial/UpdateLunchSpecial";

import AddHappyHour from "../FindagramAdmin/DealComponents/HappyHours/AddHappyHour";
import DetailHappyHour from "../FindagramAdmin/DealComponents/HappyHours/DetailHappyHour";
import UpdateHappyHour from "../FindagramAdmin/DealComponents/HappyHours/UpdateHappyHour";

import DealRequestList from "../FindagramAdmin/DealComponents/DealRequest/DealRequestList";






const authProtectedRoutes = [


//------------------ Bitesaver-------------


{ path: "/all-categories", component: CategoriesList },
{ path: "/add-categories", component: AddCategories },
{ path: "/update-categories/:id", component: UpdateCategories },


{ path: "/user-list", component: UserList },

{ path: "/business-list", component: ProfileList },
{ path: "/business-list-detail/:id", component: ResturantDetail },
{ path: "/update-business-profile/:id", component: UpdateResturant },
{ path: "/add-business-profile", component: AddBusinessProfile },




// { path: "/business-list", component: BusinessList },
{ path: "/business-detail/:id", component: BusinessDetail },

//Business Deals

{ path: "/business-deals/:businessId", component: BDealList },

//Add Daily Special

{ path: "/add-daily-special/:businessId", component: AddBDailySpecial },
{ path: "/daily-special-detail/:dealId", component: DetailDailySpecial },
{ path: "/update-daily-special/:dealId", component: UpdateDailySpecial },

//Add Lunch Special

{ path: "/add-lunch-special/:businessId", component: AddLunchSpecial },
{ path: "/lunch-special-detail/:dealId", component: DetailLunchSpecial },
{ path: "/update-lunch-special/:dealId", component: UpdateLunchSpecial },

// Happy Hours

{ path: "/add-happy-hours/:businessId", component: AddHappyHour },
{ path: "/happy-hours-detail/:dealId", component: DetailHappyHour },
{ path: "/update-happy-hours/:dealId", component: UpdateHappyHour },

{ path: "/deal-requests", component: DealRequestList  },

{ path: "/blogs-list", component: BlogsList },
{ path: "/add-blog", component: AddBlogs },
{ path: "/update-blog/:blogId", component: EditBlog },

{ path: "/bascic-tables", component: BasicTables },
{ path: "/grid-tables", component: GridTables },
{ path: "/list-tables", component: ListTables },





// aqdas

{ path: "/form-basic-elements", component: BasicElements },
{ path: "/form-select", component: FormSelect },
{ path: "/form-editor", component: FormEditor },
{ path: "/form-checkbox-radio", component: CheckBoxAndRadio },
{ path: "/form-masks", component: Masks },
{ path: "/form-file-upload", component: FileUpload },
{ path: "/form-pickers", component: FormPickers },
{ path: "/form-range-slider", component: FormRangeSlider },
{ path: "/form-layouts", component: Formlayouts },
{ path: "/form-validation", component: FormValidation },
{ path: "/form-wizard", component: FormWizard },
{ path: "/form-advanced", component: FormAdvanced },

// aqdas end


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/business-list" />,
  },
];

const publicRoutes = [
    // Authentication Page
    { path: "/logout", component: Logout },
    { path: "/login", component: Login },
    { path: "/forgot-password", component: ForgetPasswordPage },
    { path: "/register", component: Register },
    { path: "/reset-password", component: ResetPassword},


  


];

export { authProtectedRoutes, publicRoutes };